import type { IRelatedModule } from '@platform/core/types';

/**
 * Фільтр секції «Пов’язані записи» (прототип RELATED_DEFS: «Акаунти» — ролі організацій, «Контакти» — решта; синтаксис фільтра списку
 * «role:in:NGO,Business»); без фільтра — ''. Чиста функція.
 */
export function relatedFilterOf(related: Pick<IRelatedModule, 'filter'>): string {
  return related.filter?.trim() ?? '';
}
